import PostsRepository from "./postsRepository";
import UserRepository from "./UserRepository";
import AccountRepository from "./AccountRepository"
import AvatarsRepository from "./AvatarsRepository";
import FoodsRepository from "./FoodsRepository";
import HearingsRepository from "./HearingsRepository"


const repositories = {
  posts: PostsRepository,
  user: UserRepository,
  account: AccountRepository,
  avatar: AvatarsRepository,
  foods: FoodsRepository,
  hearings: HearingsRepository,
  // other repositories ...
};

export const RepositoryFactory = {
  get: name => repositories[name]
};



// WEBPACK FOOTER //
// ./src/repositories/RepositoryFactory.js